/**
 * Default expiration threshold - how long before expiration to consider something expired (5 minutes)
 */
const DEFAULT_EXPIRATION_THRESHOLD = 5 * 60 * 1000;

/**
 * Check if a given expiration date is expired or will expire soon.
 *
 * @param expiresAt - ISO date string for expiration time
 * @param threshold - Time in milliseconds before expiration to consider it expired (default: 5 minutes)
 * @returns true if expired or will expire within the threshold, false otherwise
 *
 * @example
 * // Check if a token is expired
 * const tokenExpired = isExpired(token.expiresAt);
 *
 * @example
 * // Check with custom threshold (10 minutes)
 * const sessionExpired = isExpired(session.expiresAt, 10 * 60 * 1000);
 */
export const isExpired = (expiresAt: string, threshold: number = DEFAULT_EXPIRATION_THRESHOLD): boolean => {
    const expirationTime = new Date(expiresAt).getTime();
    const now = Date.now();
    const timeUntilExpiration = expirationTime - now;

    return timeUntilExpiration <= threshold;
};
